  <template>
  <v-toolbar color="white" dark elevation="2">
    <v-toolbar-title>
      <v-img
        alt="Dutch Bros"
        class="shrink mr-2"
        contain
        src="https://files.dutchbros.com/logos/primary_logo_blue_text.png"
        transition="scale-transition"
        width="150"
      />
    </v-toolbar-title>
    <v-spacer />
    <!-- <v-toolbar-title class="hidden-sm-and-down">
      <v-btn color="primary" :href="url" target="_blank" text>
        <span class="mr-2 font-weight-bold">Employment Application</span>
        <v-icon>mdi-account-question-outline</v-icon>
      </v-btn>
    </v-toolbar-title> -->
  </v-toolbar>
</template>


<script>
  export default {
    name: 'TitleBar',
    data() {
      return {
        url: '',
      }
    },
    created() {
      this.url = this.$store.state.company.workday_url
      // console.log(this.$store.state.company.workday_url)
    }
  }
</script>